import { AkamaiColor } from '@gonfalon/sdk-logos/icons/AkamaiColor';
import { Android } from '@gonfalon/sdk-logos/icons/Android';
import { CloudflareColor } from '@gonfalon/sdk-logos/icons/CloudflareColor';
import { CPPColor } from '@gonfalon/sdk-logos/icons/CPPColor';
import { DotNetColor } from '@gonfalon/sdk-logos/icons/DotNetColor';
import { Electron } from '@gonfalon/sdk-logos/icons/Electron';
import { ErlangColor } from '@gonfalon/sdk-logos/icons/ErlangColor';
import { Flutter } from '@gonfalon/sdk-logos/icons/Flutter';
import { GoColor } from '@gonfalon/sdk-logos/icons/GoColor';
import { HaskellColor } from '@gonfalon/sdk-logos/icons/HaskellColor';
import { IosColor } from '@gonfalon/sdk-logos/icons/IosColor';
import { JavaColor } from '@gonfalon/sdk-logos/icons/JavaColor';
import { JavaScript } from '@gonfalon/sdk-logos/icons/JavaScript';
import { LuaColor } from '@gonfalon/sdk-logos/icons/LuaColor';
import { Node } from '@gonfalon/sdk-logos/icons/Node';
import { PHPColor } from '@gonfalon/sdk-logos/icons/PHPColor';
import { PythonColor } from '@gonfalon/sdk-logos/icons/PythonColor';
import { ReactJS } from '@gonfalon/sdk-logos/icons/ReactJS';
import { RokuColor } from '@gonfalon/sdk-logos/icons/RokuColor';
import { RubyColor } from '@gonfalon/sdk-logos/icons/RubyColor';
import { RustColor } from '@gonfalon/sdk-logos/icons/RustColor';
import { SalesforceColor } from '@gonfalon/sdk-logos/icons/SalesforceColor';
import { VercelWhiteColor } from '@gonfalon/sdk-logos/icons/VercelWhiteColor';
import { VueColor } from '@gonfalon/sdk-logos/icons/VueColor';

import { akamaiInit, akamaiInstallNpm, akamaiInstallYarn } from './snippets/akamai-server-edgekv-sdk';
import {
  androidExperimentationButtonCopy,
  androidInit,
  androidInstallGroovy,
  androidInstallKotlin,
} from './snippets/android-client-sdk';
import { apexInit, apexInstall } from './snippets/apex-server-sdk';
import { cloudflareInit, cloudflareInstallNpm, cloudflareInstallYarn } from './snippets/cloudflare-server-sdk';
import { cppClientInit, cppClientInstallCmake } from './snippets/cpp-client-sdk';
import { cppServerInit, cppServerInstallCmake } from './snippets/cpp-server-sdk';
import {
  dotnetClientFlagEval,
  dotnetClientFlagJsonEval,
  dotnetClientFlagNumberEval,
  dotnetClientFlagStringEval,
  dotnetClientInit,
  dotnetClientInstallCsharp,
} from './snippets/dotnet-client-sdk';
import { dotnetServerInit, dotnetServerInitEnv, dotnetServerInstallCsharp } from './snippets/dotnet-server-sdk';
import { electronInit, electronInstallNpm } from './snippets/electron-client-sdk';
import { erlangInit, erlangInstallRebar } from './snippets/erlang-server-sdk';
import { flutterInit, flutterInstallPub, flutterInstallPubspec } from './snippets/flutter-client-sdk';
import { goInit, goInitEnv, goInstall } from './snippets/go-server-sdk';
import { haskellInit, haskellInitEnv, haskellInstallCabal, haskellInstallStack } from './snippets/haskell-server-sdk';
import {
  iosExperimentationButtonCopy,
  iosInit,
  iosInstallCartfile,
  iosInstallPackageSwift,
  iosInstallPodfile,
} from './snippets/ios-client-sdk';
import {
  javaFlagEval,
  javaFlagJsonEval,
  javaFlagNumberEval,
  javaFlagStringEval,
  javaInit,
  javaInitEnv,
  javaInstallGradle,
  javaInstallXml,
} from './snippets/java-server-sdk';
import {
  jsExperimentationButtonCopy,
  jsFlagEval,
  jsFlagJsonEval,
  jsFlagNumberEval,
  jsFlagStringEval,
  jsInit,
  jsInitEnv,
  jsInitEnvObservability,
  jsInitObservability,
  jsInstallNpm,
  jsInstallNpmObservability,
  jsInstallPnpm,
  jsInstallPnpmObservability,
  jsInstallYarn,
  jsInstallYarnObservability,
} from './snippets/js-client-sdk';
import { luaInit, luaInitEnv, luaInstallLuarocks } from './snippets/lua-server-sdk';
import {
  nodeClientInit,
  nodeClientInitEnv,
  nodeClientInstallNpm,
  nodeClientInstallPnpm,
  nodeClientInstallYarn,
} from './snippets/node-client-sdk';
import {
  nodeServerFlagEval,
  nodeServerFlagJsonEval,
  nodeServerFlagNumberEval,
  nodeServerFlagStringEval,
  nodeServerInit,
  nodeServerInitEnv,
  nodeServerInstallNpm,
  nodeServerInstallPnpm,
  nodeServerInstallYarn,
} from './snippets/node-server-sdk';
import { phpInit, phpInitEnv, phpInstallComposer } from './snippets/php-server-sdk';
import {
  pythonFlagEval,
  pythonFlagJsonEval,
  pythonFlagNumberEval,
  pythonFlagStringEval,
  pythonInit,
  pythonInitEnv,
  pythonInstallPip,
} from './snippets/python-server-sdk';
import {
  reactExperimentationButtonCopy,
  reactFlagEval,
  reactFlagJsonEval,
  reactFlagNumberEval,
  reactFlagStringEval,
  reactInit,
  reactInitEnv,
  reactInitEnvObservability,
  reactInitObservability,
  reactInstallNpm,
  reactInstallNpmObservability,
  reactInstallPnpm,
  reactInstallPnpmObservability,
  reactInstallYarn,
  reactInstallYarnObservability,
} from './snippets/react-client-sdk';
import {
  reactNativeExperimentationButtonCopy,
  reactNativeInit,
  reactNativeInstallNpm,
  reactNativeInstallNpmAsyncStorage,
  reactNativeInstallPnpm,
  reactNativeInstallPnpmAsyncStorage,
  reactNativeInstallYarn,
  reactNativeInstallYarnAsyncStorage,
} from './snippets/react-native-client-sdk';
import { rokuInit, rokuInstall } from './snippets/roku-client-sdk';
import { rubyInit, rubyInitEnv, rubyInstallGem } from './snippets/ruby-server-sdk';
import { rustInit, rustInitEnv, rustInstallCargo } from './snippets/rust-server-sdk';
import { vercelInit, vercelInstallNpm, vercelInstallYarn } from './snippets/vercel-server-sdk';
import {
  vueInit,
  vueInitEnv,
  vueInitEnvObservability,
  vueInitObservability,
  vueInstallNpm,
  vueInstallNpmObservability,
  vueInstallPnpm,
  vueInstallPnpmObservability,
  vueInstallYarn,
  vueInstallYarnObservability,
} from './snippets/vue-client-sdk';
import type { FlagType, ObservabilitySnippets, SdkInfo, SdkInitKey } from './types';

/**
 * Helper to create initKey arrays with widened type (avoids tuple narrowing from `as const`)
 */
const initKeys = (...keys: SdkInitKey[]): readonly SdkInitKey[] => keys;

/**
 * SDK metadata map
 *
 * Keys follow the pattern: {platform}-{client|server}-sdk
 * Example: 'android-client-sdk', 'node-server-sdk'
 *
 * Please do not import this directly, instead use helper functions ex. getSdkInfoByKey, getSdkInstallSnippet
 * Doing so improves our bundle size. Thank you!
 *
 */
export const SDK_INFO = {
  'akamai-server-edgekv-sdk': {
    key: 'akamai-server-edgekv-sdk',
    name: 'Akamai',
    icon: AkamaiColor,
    sdkType: 'Edge',
    initKey: initKeys('clientSide'),
    docsKey: 'akamai',
    docsPath: 'sdk/edge/akamai',
    prismLang: 'javascript',
    initSnippet: akamaiInit,
    installSnippets: {
      npm: akamaiInstallNpm,
      yarn: akamaiInstallYarn,
    },
    tags: ['legacy'],
  },
  'android-client-sdk': {
    key: 'android-client-sdk',
    name: 'Android',
    icon: Android,
    sdkType: 'Client-side',
    initKey: initKeys('mobile'),
    docsKey: 'android',
    docsPath: 'sdk/client-side/android',
    prismLang: 'kotlin',
    initSnippet: androidInit,
    installSnippets: {
      groovy: androidInstallGroovy,
      kotlin: androidInstallKotlin,
    },
    experimentationSnippet: {
      trackOnly: androidExperimentationButtonCopy,
    },
    tags: ['popular', 'mobile'],
    observabilitySupported: true,
  },
  'apex-server-sdk': {
    key: 'apex-server-sdk',
    name: 'Apex',
    icon: SalesforceColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'apex',
    docsPath: 'sdk/server-side/apex',
    prismLang: 'apex',
    initSnippet: apexInit,
    installSnippets: {
      shell: apexInstall,
    },
    tags: ['legacy'],
  },
  'cpp-client-sdk': {
    key: 'cpp-client-sdk',
    name: 'C++ (Client)',
    icon: CPPColor,
    sdkType: 'Client-side',
    initKey: initKeys('mobile'),
    docsKey: 'c-c--',
    docsPath: 'sdk/client-side/c-c--',
    prismLang: 'cpp',
    initSnippet: cppClientInit,
    installSnippets: {
      cmake: cppClientInstallCmake,
    },
    tags: ['mobile', 'legacy'],
  },
  'cpp-server-sdk': {
    key: 'cpp-server-sdk',
    name: 'C++ (Server)',
    icon: CPPColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'c-c--',
    docsPath: 'sdk/server-side/c-c--',
    prismLang: 'cpp',
    initSnippet: cppServerInit,
    installSnippets: {
      cmake: cppServerInstallCmake,
    },
    tags: ['legacy'],
  },
  'cloudflare-server-sdk': {
    key: 'cloudflare-server-sdk',
    name: 'Cloudflare',
    icon: CloudflareColor,
    sdkType: 'Edge',
    initKey: initKeys('clientSide'),
    docsKey: 'cloudflare',
    docsPath: 'sdk/edge/cloudflare',
    prismLang: 'javascript',
    initSnippet: cloudflareInit,
    installSnippets: {
      npm: cloudflareInstallNpm,
      yarn: cloudflareInstallYarn,
    },
    tags: ['legacy'],
  },
  'electron-client-sdk': {
    key: 'electron-client-sdk',
    name: 'Electron',
    icon: Electron,
    sdkType: 'Client-side',
    initKey: initKeys('clientSide'),
    docsKey: 'electron',
    docsPath: 'sdk/client-side/electron',
    prismLang: 'javascript',
    initSnippet: electronInit,
    installSnippets: {
      npm: electronInstallNpm,
    },
    tags: ['legacy'],
  },
  'erlang-server-sdk': {
    key: 'erlang-server-sdk',
    name: 'Erlang',
    icon: ErlangColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'erlang',
    docsPath: 'sdk/server-side/erlang',
    prismLang: 'erlang',
    initSnippet: erlangInit,
    installSnippets: {
      rebar: erlangInstallRebar,
    },
    tags: ['legacy'],
  },
  'flutter-client-sdk': {
    key: 'flutter-client-sdk',
    name: 'Flutter',
    icon: Flutter,
    sdkType: 'Client-side',
    // Mobile-first so the key callout/labels match the init snippet's
    // YOUR_MOBILE_KEY placeholder; flutter web users can still grab the
    // client-side ID from the keys table.
    initKey: initKeys('mobile', 'clientSide'),
    docsKey: 'flutter',
    docsPath: 'sdk/client-side/flutter',
    prismLang: 'dart',
    initSnippet: flutterInit,
    installSnippets: {
      pubspec: flutterInstallPubspec,
      pub: flutterInstallPub,
    },
    tags: ['mobile'],
    wrapperName: 'FlutterClientSdk',
  },
  'go-server-sdk': {
    key: 'go-server-sdk',
    name: 'Go',
    icon: GoColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'go',
    docsPath: 'sdk/server-side/go',
    prismLang: 'go',
    initSnippet: goInit,
    initEnvVarSnippet: goInitEnv,
    installSnippets: {
      go: goInstall,
    },
    tags: ['popular'],
    observabilitySupported: true,
  },
  'haskell-server-sdk': {
    key: 'haskell-server-sdk',
    name: 'Haskell',
    icon: HaskellColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'haskell',
    docsPath: 'sdk/server-side/haskell',
    prismLang: 'haskell',
    initSnippet: haskellInit,
    initEnvVarSnippet: haskellInitEnv,
    installSnippets: {
      cabal: haskellInstallCabal,
      stack: haskellInstallStack,
    },
  },
  'ios-client-sdk': {
    key: 'ios-client-sdk',
    name: 'iOS',
    icon: IosColor,
    sdkType: 'Client-side',
    initKey: initKeys('mobile'),
    docsKey: 'ios',
    docsPath: 'sdk/client-side/ios',
    prismLang: 'swift',
    initSnippet: iosInit,
    installSnippets: {
      packageSwift: iosInstallPackageSwift,
      podfile: iosInstallPodfile,
      cartfile: iosInstallCartfile,
    },
    experimentationSnippet: {
      trackOnly: iosExperimentationButtonCopy,
    },
    tags: ['popular', 'mobile'],
    observabilitySupported: true,
  },
  'java-server-sdk': {
    key: 'java-server-sdk',
    name: 'Java',
    icon: JavaColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'java',
    docsPath: 'sdk/server-side/java',
    prismLang: 'java',
    initSnippet: javaInit,
    initEnvVarSnippet: javaInitEnv,
    installSnippets: {
      xml: javaInstallXml,
      gradle: javaInstallGradle,
    },
    flagEvalSnippet: {
      boolean: javaFlagEval,
      string: javaFlagStringEval,
      number: javaFlagNumberEval,
      json: javaFlagJsonEval,
    },
    tags: ['popular'],
    observabilitySupported: true,
  },
  'js-client-sdk': {
    key: 'js-client-sdk',
    name: 'JavaScript',
    icon: JavaScript,
    sdkType: 'Client-side',
    initKey: initKeys('clientSide'),
    docsKey: 'javascript',
    docsPath: 'sdk/client-side/javascript',
    prismLang: 'javascript',
    initSnippet: jsInit,
    initEnvVarSnippet: jsInitEnv,
    installSnippets: {
      yarn: jsInstallYarn,
      npm: jsInstallNpm,
      pnpm: jsInstallPnpm,
    },
    observabilitySnippets: {
      initSnippet: jsInitObservability,
      initEnvVarSnippet: jsInitEnvObservability,
      installSnippets: {
        yarn: jsInstallYarnObservability,
        npm: jsInstallNpmObservability,
        pnpm: jsInstallPnpmObservability,
      },
    },
    flagEvalSnippet: {
      boolean: jsFlagEval,
      string: jsFlagStringEval,
      number: jsFlagNumberEval,
      json: jsFlagJsonEval,
    },
    experimentationSnippet: {
      trackOnly: jsExperimentationButtonCopy,
    },
    tags: ['popular'],
    observabilitySupported: true,
  },
  'lua-server-sdk': {
    key: 'lua-server-sdk',
    name: 'Lua',
    icon: LuaColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'lua',
    docsPath: 'sdk/server-side/lua',
    prismLang: 'lua',
    initSnippet: luaInit,
    initEnvVarSnippet: luaInitEnv,
    installSnippets: {
      luarocks: luaInstallLuarocks,
    },
    tags: ['legacy'],
  },
  'dotnet-client-sdk': {
    key: 'dotnet-client-sdk',
    name: '.NET (Client)',
    icon: DotNetColor,
    sdkType: 'Client-side',
    initKey: initKeys('mobile'),
    docsKey: 'dotnet',
    docsPath: 'sdk/client-side/dotnet',
    prismLang: 'csharp',
    initSnippet: dotnetClientInit,
    installSnippets: {
      csharp: dotnetClientInstallCsharp,
    },
    flagEvalSnippet: {
      boolean: dotnetClientFlagEval,
      string: dotnetClientFlagStringEval,
      number: dotnetClientFlagNumberEval,
      json: dotnetClientFlagJsonEval,
    },
    tags: ['mobile', 'legacy'],
  },
  'dotnet-server-sdk': {
    key: 'dotnet-server-sdk',
    name: '.NET (Server)',
    icon: DotNetColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'dotnet',
    docsPath: 'sdk/server-side/dotnet',
    prismLang: 'csharp',
    initSnippet: dotnetServerInit,
    initEnvVarSnippet: dotnetServerInitEnv,
    installSnippets: {
      csharp: dotnetServerInstallCsharp,
    },
    tags: ['popular'],
    observabilitySupported: true,
  },
  'node-client-sdk': {
    key: 'node-client-sdk',
    name: 'Node.js (Client)',
    icon: Node,
    sdkType: 'Client-side',
    initKey: initKeys('clientSide'),
    docsKey: 'node-js',
    docsPath: 'sdk/client-side/node-js',
    prismLang: 'javascript',
    initSnippet: nodeClientInit,
    initEnvVarSnippet: nodeClientInitEnv,
    installSnippets: {
      yarn: nodeClientInstallYarn,
      npm: nodeClientInstallNpm,
      pnpm: nodeClientInstallPnpm,
    },
    tags: ['mobile', 'legacy'],
  },
  'node-server-sdk': {
    key: 'node-server-sdk',
    name: 'Node.js (Server)',
    icon: Node,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'node-js',
    docsPath: 'sdk/server-side/node-js',
    prismLang: 'typescript',
    initSnippet: nodeServerInit,
    initEnvVarSnippet: nodeServerInitEnv,
    installSnippets: {
      yarn: nodeServerInstallYarn,
      npm: nodeServerInstallNpm,
      pnpm: nodeServerInstallPnpm,
    },
    flagEvalSnippet: {
      boolean: nodeServerFlagEval,
      string: nodeServerFlagStringEval,
      number: nodeServerFlagNumberEval,
      json: nodeServerFlagJsonEval,
    },
    tags: ['popular'],
    observabilitySupported: true,
  },
  'php-server-sdk': {
    key: 'php-server-sdk',
    name: 'PHP',
    icon: PHPColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'php',
    docsPath: 'sdk/server-side/php',
    prismLang: 'php',
    initSnippet: phpInit,
    initEnvVarSnippet: phpInitEnv,
    installSnippets: {
      composer: phpInstallComposer,
    },
  },
  'python-server-sdk': {
    key: 'python-server-sdk',
    name: 'Python',
    icon: PythonColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'python',
    docsPath: 'sdk/server-side/python',
    prismLang: 'python',
    initSnippet: pythonInit,
    initEnvVarSnippet: pythonInitEnv,
    installSnippets: {
      pip: pythonInstallPip,
    },
    flagEvalSnippet: {
      boolean: pythonFlagEval,
      string: pythonFlagStringEval,
      number: pythonFlagNumberEval,
      json: pythonFlagJsonEval,
    },
    tags: ['popular'],
    observabilitySupported: true,
  },
  'react-client-sdk': {
    key: 'react-client-sdk',
    name: 'React Web',
    icon: ReactJS,
    sdkType: 'Client-side',
    initKey: initKeys('clientSide'),
    docsKey: 'react',
    docsPath: 'sdk/client-side/react',
    prismLang: 'tsx',
    initSnippet: reactInit,
    initEnvVarSnippet: reactInitEnv,
    installSnippets: {
      yarn: reactInstallYarn,
      npm: reactInstallNpm,
      pnpm: reactInstallPnpm,
    },
    observabilitySnippets: {
      initSnippet: reactInitObservability,
      initEnvVarSnippet: reactInitEnvObservability,
      installSnippets: {
        yarn: reactInstallYarnObservability,
        npm: reactInstallNpmObservability,
        pnpm: reactInstallPnpmObservability,
      },
    },
    flagEvalSnippet: {
      boolean: reactFlagEval,
      string: reactFlagStringEval,
      number: reactFlagNumberEval,
      json: reactFlagJsonEval,
    },
    experimentationSnippet: {
      trackOnly: reactExperimentationButtonCopy,
    },
    tags: ['popular'],
    observabilitySupported: true,
    wrapperName: 'react-client-sdk',
  },
  'react-native-client-sdk': {
    key: 'react-native-client-sdk',
    name: 'React Native',
    icon: ReactJS,
    sdkType: 'Client-side',
    initKey: initKeys('mobile'),
    docsKey: 'react-native',
    docsPath: 'sdk/client-side/react-native',
    prismLang: 'tsx',
    initSnippet: reactNativeInit,
    installSnippets: {
      yarn: reactNativeInstallYarn,
      npm: reactNativeInstallNpm,
      pnpm: reactNativeInstallPnpm,
      asyncStorage: {
        yarn: reactNativeInstallYarnAsyncStorage,
        npm: reactNativeInstallNpmAsyncStorage,
        pnpm: reactNativeInstallPnpmAsyncStorage,
      },
    },
    experimentationSnippet: {
      trackOnly: reactNativeExperimentationButtonCopy,
    },
    tags: ['popular', 'mobile'],
    observabilitySupported: true,
  },
  'roku-client-sdk': {
    key: 'roku-client-sdk',
    name: 'Roku',
    icon: RokuColor,
    sdkType: 'Client-side',
    initKey: initKeys('mobile'),
    docsKey: 'roku',
    docsPath: 'sdk/client-side/roku',
    prismLang: 'brightscript',
    initSnippet: rokuInit,
    installSnippets: {
      shell: rokuInstall,
    },
    tags: ['mobile'],
  },
  'ruby-server-sdk': {
    key: 'ruby-server-sdk',
    name: 'Ruby / Rails',
    icon: RubyColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'ruby',
    docsPath: 'sdk/server-side/ruby',
    prismLang: 'ruby',
    initSnippet: rubyInit,
    initEnvVarSnippet: rubyInitEnv,
    installSnippets: {
      gem: rubyInstallGem,
    },
  },
  'rust-server-sdk': {
    key: 'rust-server-sdk',
    name: 'Rust',
    icon: RustColor,
    sdkType: 'Server-side',
    initKey: initKeys('serverSide'),
    docsKey: 'rust',
    docsPath: 'sdk/server-side/rust',
    prismLang: 'rust',
    initSnippet: rustInit,
    initEnvVarSnippet: rustInitEnv,
    installSnippets: {
      cargo: rustInstallCargo,
    },
  },
  'vercel-server-sdk': {
    key: 'vercel-server-sdk',
    name: 'Vercel',
    icon: VercelWhiteColor,
    sdkType: 'Edge',
    initKey: initKeys('clientSide'),
    docsKey: 'vercel',
    docsPath: 'sdk/edge/vercel',
    prismLang: 'javascript',
    initSnippet: vercelInit,
    installSnippets: {
      npm: vercelInstallNpm,
      yarn: vercelInstallYarn,
    },
    tags: ['legacy'],
  },
  'vue-client-sdk': {
    key: 'vue-client-sdk',
    name: 'Vue',
    icon: VueColor,
    sdkType: 'Client-side',
    initKey: initKeys('clientSide'),
    docsKey: 'vue',
    docsPath: 'sdk/client-side/vue',
    prismLang: 'javascript',
    initSnippet: vueInit,
    initEnvVarSnippet: vueInitEnv,
    installSnippets: {
      yarn: vueInstallYarn,
      npm: vueInstallNpm,
      pnpm: vueInstallPnpm,
    },
    observabilitySnippets: {
      initSnippet: vueInitObservability,
      initEnvVarSnippet: vueInitEnvObservability,
      installSnippets: {
        yarn: vueInstallYarnObservability,
        npm: vueInstallNpmObservability,
        pnpm: vueInstallPnpmObservability,
      },
    },
    observabilitySupported: true,
    wrapperName: 'vue-client-sdk',
  },
} as const satisfies Record<string, SdkInfo>;

/* Popular SDK keys - curated order for UI display */
export const POPULAR_SDK_KEYS = [
  'react-client-sdk',
  'js-client-sdk',
  'node-server-sdk',
  'python-server-sdk',
  'react-native-client-sdk',
  'dotnet-server-sdk',
  'java-server-sdk',
  'go-server-sdk',
  'ios-client-sdk',
  'android-client-sdk',
] as const satisfies readonly SdkKey[];

/* Popular SDK Keys */
export const POPULAR_SDKS = POPULAR_SDK_KEYS.map((key) => SDK_INFO[key]) as readonly SdkInfo[];

/* Mobile SDK keys */
export const MOBILE_SDK_KEYS = Object.entries(SDK_INFO)
  .filter(([_, sdk]) => 'tags' in sdk && Array.isArray(sdk.tags) && sdk.tags?.includes('mobile'))
  .map(([key]) => key) as readonly SdkKey[];

/* Legacy SDK keys */
export const LEGACY_SDK_KEYS = Object.entries(SDK_INFO)
  .filter(([_, sdk]) => 'tags' in sdk && Array.isArray(sdk.tags) && sdk.tags?.includes('legacy'))
  .map(([key]) => key) as readonly SdkKey[];

/* Server-side SDKs */
const serverSideEntries = Object.entries(SDK_INFO).filter(([_, sdk]) => sdk.sdkType === 'Server-side');
export const SERVER_SIDE_SDK_KEYS = serverSideEntries.map(([key]) => key) as readonly SdkKey[];
export const SERVER_SIDE_SDKS = serverSideEntries.map(([_, sdk]) => sdk) as readonly SdkInfo[];

/* Client-side SDKs */
const clientSideEntries = Object.entries(SDK_INFO).filter(([_, sdk]) => sdk.sdkType === 'Client-side');
export const CLIENT_SIDE_SDK_KEYS = clientSideEntries.map(([key]) => key) as readonly SdkKey[];
export const CLIENT_SIDE_SDKS = clientSideEntries.map(([_, sdk]) => sdk) as readonly SdkInfo[];

/* Edge SDKs */
const edgeEntries = Object.entries(SDK_INFO).filter(([_, sdk]) => sdk.sdkType === 'Edge');
export const EDGE_SDK_KEYS = edgeEntries.map(([key]) => key) as readonly SdkKey[];
export const EDGE_SDKS = edgeEntries.map(([_, sdk]) => sdk) as readonly SdkInfo[];

/* All SDKs */
export const ALL_SDK_KEYS = Object.keys(SDK_INFO) as readonly SdkKey[];
export const ALL_SDKS = Object.values(SDK_INFO) as readonly SdkInfo[];

/* Type for SDK keys (all available SDK identifiers) */
export type SdkKey = keyof typeof SDK_INFO;

/**
 * @deprecated
 *
 * Please use `SdkKey`
 *
 */
export type SdkKebabName = SdkKey;

/* Re-export types from types.ts for convenience */
export type { SdkInfo, SdkType, SdkInitKey, SdkTag, FlagType, FlagEvalSnippet, ObservabilitySnippets } from './types';

/* Type for popular SDK keys */
export type PopularSdkKey = (typeof POPULAR_SDK_KEYS)[number];

/* Type guard to check if a string is a valid SDK key */
export function isSdkKey(key: string): key is SdkKey {
  return key in SDK_INFO;
}

/* Get SDK by key  */
export function getSdkInfoByKey(key: SdkKey): SdkInfo {
  return SDK_INFO[key];
}

/* Get install snippet for a specific package manager */
export function getSdkInstallSnippet(sdkKey: SdkKey, packageManager: string): string {
  const sdkInfo = SDK_INFO[sdkKey] as SdkInfo;
  const snippet = sdkInfo.installSnippets?.[packageManager];
  return typeof snippet === 'string' ? snippet : '';
}

export type FlagEvalSdk = Extract<(typeof SDK_INFO)[keyof typeof SDK_INFO], { flagEvalSnippet: unknown }>['key'];

export function isFlagEvalSdk(key: SdkKey): key is FlagEvalSdk {
  const sdkInfo = SDK_INFO[key];
  return 'flagEvalSnippet' in sdkInfo;
}

export type EnvVarInitSdk = Extract<(typeof SDK_INFO)[keyof typeof SDK_INFO], { initEnvVarSnippet: unknown }>['key'];

export function isEnvVarInitSdk(key: SdkKey): key is EnvVarInitSdk {
  const sdkInfo = SDK_INFO[key];
  return 'initEnvVarSnippet' in sdkInfo;
}

/* Get the initialization snippet reading the key from a LAUNCHDARKLY_* environment variable */
export function getSdkEnvVarInitSnippet(sdkKey: EnvVarInitSdk): string {
  return SDK_INFO[sdkKey].initEnvVarSnippet;
}

export type ObservabilitySnippetSdk = Extract<
  (typeof SDK_INFO)[keyof typeof SDK_INFO],
  { observabilitySnippets: unknown }
>['key'];

export function isObservabilitySnippetSdk(key: SdkKey): key is ObservabilitySnippetSdk {
  const sdkInfo = SDK_INFO[key];
  return 'observabilitySnippets' in sdkInfo;
}

export function getSdkObservabilitySnippets(sdkKey: ObservabilitySnippetSdk): ObservabilitySnippets {
  return SDK_INFO[sdkKey].observabilitySnippets;
}

/* Check if the SDK has an initialization snippet; docs-link-only SDKs have none */
export function hasInitSnippet(key: SdkKey): boolean {
  return 'initSnippet' in SDK_INFO[key];
}

const CREDENTIAL_PLACEHOLDERS = ['YOUR_SDK_KEY', 'YOUR_MOBILE_KEY', 'YOUR_CLIENT_SIDE_ID'];

/* True when the init snippet embeds a credential placeholder we substitute; false for
   SDKs whose key lives outside the snippet (Apex reads it in the bridge process). */
export function initSnippetIncludesCredential(key: SdkKey): boolean {
  const sdkInfo = SDK_INFO[key];
  return (
    'initSnippet' in sdkInfo && CREDENTIAL_PLACEHOLDERS.some((placeholder) => sdkInfo.initSnippet.includes(placeholder))
  );
}

/* Get flag evaluation snippet for a specific SDK and flag type */
export function getSdkFlagEvalSnippet(sdkKey: FlagEvalSdk, flagType: FlagType = 'boolean'): string {
  const snippet = SDK_INFO[sdkKey].flagEvalSnippet[flagType];
  return typeof snippet === 'string' ? snippet : '';
}

const POPULAR_SDK_KEYS_SET = new Set(POPULAR_SDK_KEYS);

/* Check if a SDK is popular */
export function isPopularSdk(key: SdkKey): key is PopularSdkKey {
  return (POPULAR_SDK_KEYS_SET as Set<SdkKey>).has(key);
}

export { default as sdkInstallPromptTemplate } from './snippets/prompt.txt?raw';
